<template>
    <div class="overflow-x-hidden">
        <section
            class="impact-section text-center bridging-section grid flex flex-wrap justify-content-center align-items-center md:w-full md:px-8 ">
            <div class="col-10">
                <span class="badge mb-2">Impact</span>
                <h2 class="LandingPage-Title mb-1 ">
                    Our Impact
                </h2>
                <p class="Paragraph-Medium font-semibold  mx-auto pb-4">
                    We believe knowledge has the power to shape lives
                </p>
                <p class="Paragraph-Regular mx-auto">
                    Over time, ILearn’d Tutors aims to connect thousands of students with tutors who inspire confidence,
                    curiosity, and success — no matter where they are on the island.
                </p>
            </div>
            <div class="container p-4 md:px-7">
                <!-- Features with Alternating Layout -->
                <div class="features-container py-4 md:px-6 px-4">
                    <div v-for="(feature, index) in impactFeatures" :key="index" class="feature-row mb-4 " >
                        <div class="grid align-items-center " :class="index % 2 === 0 ? 'flex-row-reverse' : ''" v-animateonscroll="{ enterClass: 'fade-in-up'}">

                            <!-- Text Content -->
                            <div class="col-12 md:col-6 ">
                                <div class="feature-content">
                                    <h3 class="H5-SemiBold text-left mb-4 "
                                        :class="index % 2 === 1 ? 'text-right' : ''">
                                        {{ feature.title }}
                                    </h3>
                                    <p class="text-left Paragraph-Regular leading-relaxed mb-0"
                                        :class="index % 2 === 1 ? 'text-right' : ''">
                                        {{ feature.description }}
                                    </p>
                                </div>
                            </div>

                            <!-- Image -->
                            <div class="col-12 md:col-6">
                                <div class="feature-visual px-4">
                                    <img :src="feature.imageUrl" :alt="feature.title"
                                        class="w-full border-round-xl shadow-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { usePublicUrl } from "@/utils/getPublicUrl"
import { ref, onMounted } from 'vue';

const impactFeatures = ref([
    {
        title: "Bridging the Gap",
        description: "Connecting students and tutors across every corner of Sri Lanka — from cities to rural communities",
        image: "public/bridge-gap1.jpg",
        imageUrl:""
    },
    {
        title: "Empowering Educators",
        description: "Helping tutors gain recognition, earn stable income, and build sustainable teaching careers.",
        image: "public/bridge-gap5.png",
        imageUrl:""
    },
    {
        title: "Accessible Learning",
        description: "Making quality education available anytime, anywhere through an easy-to-use digital platform.",
        image: "public/bridge-gap3.jpg",
        imageUrl:""
        
    },
    {
        title: "Smarter Study Support:",
        description: " Providing students with tools like notes, past papers, and homework features to boost performance.",
        image: "public/bridge-gap2.jpg",
        imageUrl:""
    },
    {
        title: "Encouraging Lifelong Learning:",
        description: "Inspiring curiosity, creativity, and confidence beyond the classroom.",
        image: "public/bridge-gap4.jpg",
        imageUrl:""
    }
]);

onMounted(async () => {
    for (let feature of impactFeatures.value) {
        try {
            const url = await usePublicUrl(feature.image);
            feature.imageUrl = url;
        } catch (error) {
            console.error('Error loading image:', feature.image, error);
        }
    }
});
</script>
<style scoped>
.impact-section .features-container {
    background-color: #F5A67B;
    border-radius: 32px;
}
.Paragraph-Regular{
    color: #515961;
}
</style>